<!--
발송작업 > 재고상품
-->
<template>
    <div>
        <div class="uk-card uk-card-default simple-card uk-card-small">

            <div class="uk-card-body p-1rem">

                <div class="title">
                    <i class="material-icons">add_shopping_cart</i>
                    <span class="uk-text-middle">재고상품 (가져오세요)</span>
                </div>


                <div class="uk-flex uk-flex-between">

                    <div class="uk-width-auto">
                        <!-- 이미지 -->
                        <img-zoom :src="stockProd.img_url" disable-preview style="width: 15rem; height: 15rem"></img-zoom>
                    </div>

                    <div class="uk-width-expand">

                        <!-- 상품정보 -->
                        <table class="prod-info mb-1rem">

                            <tr >
                                <th class="highlight">
                                    보관장소
                                </th>
                                <td class="highlight bold">
                                    {{ stockProd.storage }}
                                </td>
                            </tr>
                            <tr >
                                <th class="highlight">
                                    상품번호
                                </th>
                                <td class="highlight">
                                    <div class="uk-flex uk-flex-middle">
                                        <div class="uk-width-expand">
                                            {{ stockProd.id_3digits }}
                                        </div>

                                        <!-- 상세버튼 -->
                                        <button
                                            type="button"
                                            class="uk-button uk-button-white"
                                            onclick="$.app.on_event.move(arguments);"
                                            :data-url="'/prods/' + stockProd.id"
                                            data-target="_blank"
                                        >
                                            <span uk-icon="icon: link"></span>
                                            상품상세
                                        </button>
                                    </div>



                                </td>
                            </tr>
                            <tr >
                                <th :class="stockOutAmount > 1 ? 'highlight' : ''">
                                    가져올 수량
                                </th>
                                <td class="highlight amount">
                                    {{ stockOutAmount }}
                                </td>

                            </tr>
                            <tr >
                                <th>
                                    재고 잔량
                                </th>
                                <td class="remain-amount">
                                    {{ stockProd.amount }}
                                </td>

                            </tr>

                        </table>

                        <table class="prod-info">


                            <tr>
                                <th >
                                    COLOR
                                </th>
                                <td >
                                    {{ stockProd.color }}
                                </td>
                            </tr>
                            <tr>
                                <th >
                                    SIZE
                                </th>
                                <td >
                                    {{ stockProd.size }}
                                </td>

                            </tr>


                            <tr>
                                <th>
                                    NAME
                                </th>
                                <td class="name">
                                    {{ stockProd.name }}
                                    <app-column
                                        header="상품명(영문)"
                                        horizontal
                                        header-align="right"
                                        body-align="left"
                                        body-size="medium"
                                        v-show="stockProd.name_eng"
                                    >
                                        {{ stockProd.name_eng }}
                                    </app-column>
                                </td>
                            </tr>

                            <tr>
                                <th>
                                    회원사서함
                                </th>
                                <td>
                                    {{ stockProd.user_mailbox }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
            'img-zoom': require('../common/img-zoom.vue').default,
        },
        props: {
            // 재고상품
            stockProd: Object,

            // 재고발송수량
            stockOutAmount: Number,
        },
        data: function () {
            return {
            };
        },
        computed: {
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
    .title {
        color: #000;
        font-size: 1.25rem;
        //font-weight: bold;
        text-align: left;
        background-color: #fff;

        .material-icons {
            font-size: 1.5rem;
        }
    }


    // 상품정보 테이블
    .prod-info {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        th, td {
            text-align: center;
            border: 1px solid #cfcfcf;
            font-weight: normal;

            padding: 2px;
            color: #000;
        }

        th {
            font-size: 1.25rem;
            background-color: #fefefe;
            width: 7rem;

            .material-icons {
                vertical-align: middle;
                font-size: 1.75rem;
                color: #aaa;
            }

            &.highlight .material-icons{
                color: #1e87f0 !important;
            }

        }
        td {
            font-size: 1.75rem;
            color: #000;


            &.name {
                font-size: 1.25rem;
            }
            &.amount {
                font-size: 2.5rem;
                color: #ff0000 !important;
                font-weight: bold;

            }

            &.remain-amount {
                font-size: 2.5rem;
            }

            &.highlight {
                background-color: #ffffdd;


            }

            &.bold {
                font-weight: bold !important;
            }


        }

    }
</style>